import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import HttpErrorResponse from '../interfaces/common/httpErrorResponse';
import Paging from '../interfaces/common/paging';
import Pagination from '../interfaces/common/pagination';
import { RootState } from '../setup';
import ReconcileStatus from '../interfaces/output/reconcileStatus';

export type ReconcileStatusState = {
    reconcileStatus: ReconcileStatus;
    isLoading: boolean;
    reconcileStatuses: Pagination<ReconcileStatus>;
    error: HttpErrorResponse | undefined;
};

const initialState: ReconcileStatusState = {
    reconcileStatus: {} as ReconcileStatus,
    reconcileStatuses: { content: [] as Array<ReconcileStatus> } as Pagination<ReconcileStatus>,
    isLoading: false,
    error: undefined
};

export const reconcileStatusSlice = createSlice({
    name: 'reconcileStatus',

    initialState,
    reducers: {
        fetchReconcileStatuses: (state: ReconcileStatusState, _action: PayloadAction<{ paging: Paging }>) => {
            state.isLoading = true;
        },
        fetchReconcileStatusesSuccess: (state: ReconcileStatusState, action: PayloadAction<Pagination<ReconcileStatus>>) => {
            state.isLoading = false;
            state.reconcileStatuses = action.payload;
        },
        fetchReconcileStatusesError: (state: ReconcileStatusState, action: PayloadAction<HttpErrorResponse>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        fetchReconcileStatusById: (state: ReconcileStatusState, _action: PayloadAction<string>) => {
            state.isLoading = true;
        },
        fetchReconcileStatusByIdSuccess: (state: ReconcileStatusState, action: PayloadAction<ReconcileStatus>) => {
            state.isLoading = false;
            state.reconcileStatus = action.payload;
        },
        fetchReconcileStatusByIdError: (state: ReconcileStatusState, action: PayloadAction<HttpErrorResponse>) => {
            state.isLoading = false;
            state.error = action.payload;
        }
    }
});

export const { fetchReconcileStatuses, fetchReconcileStatusesError, fetchReconcileStatusesSuccess, fetchReconcileStatusById,
    fetchReconcileStatusByIdError, fetchReconcileStatusByIdSuccess } = reconcileStatusSlice.actions;

export const isLoadingReconcileStatuses = (state: RootState): boolean => state.reconcileStatusReducer.isLoading;
export const getReconcileStatuses = (state: RootState): Pagination<ReconcileStatus> => state.reconcileStatusReducer.reconcileStatuses;
export const getReconcileStatus = (state: RootState): ReconcileStatus => state.reconcileStatusReducer.reconcileStatus;

export default reconcileStatusSlice.reducer;